<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mriq8f/tc-custom/9781636240893.jpg?1721404630505" alt="This image is the cover for the book Cast of Falcons, Casemate Fiction"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cast of Falcons, Casemate Fiction
      </h1>
      <p class="bookDescription body article font2">
        <p>"Casemate has a long history of publishing high quality military history non-fiction. Lately, they have expanded their range of work to include well written novels using wartime settings." – WWII History MagazineYoung pilots of the Royal Flying Corps take to the air above the Sinai desert in 1916 to fight German pilots flying far superior aircraft. Will their determination and aggressive spirit be enough to prevail?<br/><br/>Phillip Parotti’s new novel offers fast-paced action in the skies over the Sinai desert in 1916. Lieutenant Devlin Collins, an Irish-American flier in the Royal Flying Corps, expecting to fly on the Western Front, instead finds himself flying antiquated two-seater bomber and photo reconnaissance missions over the Egyptian desert against the forces of the Central Powers which are trying to capture the Suez Canal. Pitted against German machines which are up-to-date and well equipped, the men of the RFC fight at a considerable disadvantage as they go forth to meet their enemy, but committed to their cause and with aggressive spirit, no matter how great the stress of battle, they proceed and prevail, continually forcing the Turks and Germans back as the army moves slowly toward Palestine. Constantly endangered by superior German machines, facing incessant ground fire during their bombing and strafing attacks, Dev and his fellow pilot Crisp drive home their attacks with unremitting determination. In the off hours from combat, Dev discovers that he has a particular talent for planning his flight’s air raids. This talent manifests itself completely in the campaign’s culminating attack on the German redoubts at the battle of Magdhaba, an attack so successful that when the pilots are finally pulled back for a rest after a year of fighting, Dev is promoted and invited onto the staff at GHQ is order to apply his expertise to air planning as the army moves on Gaza with the intention of driving into Palestine.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phillip Parotti
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9a0971ea